module.exports = __webpack_public_path__ + "static/media/bbb-food-menu2.984e4662.png";